import React  from "react";
import {useEffect,useState }  from "react";
import AxiosInstance from '../../../services/AxiosInstance';
import {REQUEST_TYPE_URL} from '../../../Constants/Constants';
import Container from 'react-bootstrap/Container';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import Box from '@mui/material/Box';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

function RequestType(){  

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
      }));

      const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      }));

  const [data, setData] = useState([]);    

  useEffect(() => {
    getRequestTypes();     
  }, []);
   
    
  const [page, setPage] = React.useState(0);    
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  
    
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    
    const getRequestTypes = () => {
      AxiosInstance.get(REQUEST_TYPE_URL).then(response => setData(response.data));      
    }
    const saveRequestType = (rtName)=>{
      AxiosInstance.post(REQUEST_TYPE_URL, {name:rtName})
      .then((response) => {alert("Request Type created successfully!");getRequestTypes();})
      .catch((error)=>{
        alert("Request Type creation failed!")
        console.error(error)
      });
    }

    const visibleRows = React.useMemo(
        () =>
          [...data]            
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
        [data, page, rowsPerPage],
      );

  return (
    <Container fluid>      
      <fieldset >
        <legend>Request Type</legend>
        <React.Fragment>
            <Button variant="outlined" onClick={handleClickOpen} style={{float:"right", margin:"5px"}}>
              Add Request Type
            </Button>
              <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                  component: 'form',
                  onSubmit: (event) => {
                    event.preventDefault();
                    const formData = new FormData(event.currentTarget);
                    const formJson = Object.fromEntries((formData).entries());
                    const name = formJson.name;
                    console.log(name);
                    saveRequestType(name);                    
                    handleClose();
                  },
                }}
              >
                <DialogTitle>Add Request Type</DialogTitle>
                <DialogContent>
                  {/* <DialogContentText>
                    To subscribe to this website, please enter your email address here. We
                    will send updates occasionally.
                  </DialogContentText> */}
                  <TextField
                    autoFocus
                    required
                    margin="dense"
                    id="rg"
                    name="name"
                    label="Request Type"
                    type="text"
                    fullWidth
                    variant="standard"
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button type="submit">Add </Button>
                </DialogActions>
              </Dialog>
            </React.Fragment>
            <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2 }}>
                                <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                    <TableRow>
                        <StyledTableCell>RequestType ID</StyledTableCell>
                        <StyledTableCell>RequestType</StyledTableCell>
                        
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {visibleRows.map((rt, index) => {                
                            return (                    
                                    <StyledTableRow>
                                    <StyledTableCell>{rt.id}</StyledTableCell>
                                    <StyledTableCell>{rt.name}</StyledTableCell>
                                    
                                    </StyledTableRow>
                                    )
                                })}        
                
                    
                    </TableBody>
                </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                    </Paper>
                    </Box>
                </fieldset>
            </Container>
        )
}
//https://mui.com/material-ui/react-table/#custom-pagination-actions
export default RequestType;